module.exports = __webpack_public_path__ + "static/media/confirm__title.00e80130.png";